export const getProperty = <K extends keyof any>(obj: any, key: K) => obj[key];
